/** Sections the Documents hub shows, in order. Keys match the server's section keys. */ export const DOCUMENT_SECTIONS = [
    {
        key: 'solicitation',
        label: 'Solicitation & amendments',
        empty: 'Nothing from the government yet. Upload the RFP and any amendments here.'
    },
    {
        key: 'volumes',
        label: 'Our volumes',
        empty: 'No volume documents have been created yet.'
    },
    {
        key: 'pricing',
        label: 'Pricing',
        empty: 'No pricing workbooks yet.'
    },
    {
        key: 'past_performance',
        label: 'Past performance & resumes',
        empty: 'No past performance or resumes yet.'
    },
    {
        key: 'teaming',
        label: 'Teaming & NDAs',
        empty: 'No teaming agreements or NDAs yet.'
    },
    {
        key: 'reviews',
        label: 'Review outputs',
        empty: 'No review reports yet.'
    },
    {
        key: 'submission',
        label: 'Submission package',
        empty: 'Nothing is marked for the package yet.'
    },
    {
        key: 'pursuit',
        label: 'From the pursuit',
        empty: 'The linked pursuit has no documents left to bring in.'
    },
    {
        key: 'library',
        label: 'From the Library',
        empty: 'Nothing has been brought in from the Library.'
    },
    {
        key: 'other',
        label: 'Other & references',
        empty: 'No other documents yet.'
    }
];
/** Categories a file can be filed under (the server's accepted hub categories). */ export const DOCUMENT_CATEGORIES = [
    {
        value: 'solicitation',
        label: 'Solicitation'
    },
    {
        value: 'amendment',
        label: 'Amendment'
    },
    {
        value: 'qa',
        label: 'Questions and answers'
    },
    {
        value: 'gov_template',
        label: 'Government template'
    },
    {
        value: 'pricing_workbook',
        label: 'Pricing workbook'
    },
    {
        value: 'past_performance',
        label: 'Past performance'
    },
    {
        value: 'resume',
        label: 'Resume'
    },
    {
        value: 'teaming_agreement',
        label: 'Teaming agreement'
    },
    {
        value: 'nda',
        label: 'NDA'
    },
    {
        value: 'review_report',
        label: 'Review report'
    },
    {
        value: 'final_submission',
        label: 'Final submission file'
    },
    {
        value: 'reference',
        label: 'Reference'
    },
    {
        value: 'other',
        label: 'Other'
    }
];
export const PRICING_CATEGORY = 'pricing_workbook';
export function categoryLabel(value) {
    return DOCUMENT_CATEGORIES.find((c)=>c.value === value)?.label ?? value;
}
/** Categories one caller may choose: a Pricing-only caller only gets pricing. */ export function categoriesFor(canUpload) {
    return canUpload ? DOCUMENT_CATEGORIES : DOCUMENT_CATEGORIES.filter((c)=>c.value === PRICING_CATEGORY);
}
export const SENSITIVITIES = [
    {
        value: '',
        label: 'Standard (legal files default to restricted)'
    },
    {
        value: 'standard',
        label: 'Standard'
    },
    {
        value: 'legal_restricted',
        label: 'Restricted to legal'
    }
];
